import { render, staticRenderFns } from "./AnalysisMaterialLifecycle.vue?vue&type=template&id=23f42d46&scoped=true"
import script from "./AnalysisMaterialLifecycle.vue?vue&type=script&lang=js"
export * from "./AnalysisMaterialLifecycle.vue?vue&type=script&lang=js"
import style0 from "./AnalysisMaterialLifecycle.vue?vue&type=style&index=0&id=23f42d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f42d46",
  null
  
)

export default component.exports